<template>
    <div class="app_list">
        <div class="title">
            <van-icon name="cross" class="close" color="#000" @click="handleClose"/>
            <p class="tit">请选择游戏市场</p>
            <van-search show-action v-model="game_name" placeholder="请输入游戏名称" @search="onSearch">
                <template #action><div class="action" @click="onSearch">搜索</div></template>
            </van-search>
        </div>
        <div class="scrollbar content" v-if="appList.length > 0">
            <div v-for="(item,i) in appList" :key="i" :class="{'app_item':true,'active': gameId == item.id}"
                @click="chooseGame(item.app_name,item.icon,item.id,item.prop_trade,item.role_trade)">
                <div class="icon">
                    <img class="icon_img" :src="item.icon" alt="">
                </div>
                <div class="name">{{ item.app_name }}</div>
            </div>
        </div>
        <p v-if="appList.length == 0&&game_name != ''" class="nodate">未搜索到游戏</p>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                allApplist: [],
                appList: [],
                role: [],
                game_name: ''
            }
        },
        props: {
            notUserRoleList: Boolean
        },
        computed: {
            gameId() {
                return this.$store.state.gameId
            },
            isIos() {
                return /iphone|ipod|ipad/.test(navigator.userAgent.toLowerCase())
            }
        },
        mounted() {
            this.getAppList()
        },
        methods: {
            getAppList() {
                this.$Ajax('game/app-list').then(rs => {
                    if (rs.code == 200) {
                        this.allApplist = this.appList = rs.data
                    }
                })
            },
            chooseGame(name, icon, id,prop_trade,role_trade) {
                this.$store.commit('resetServer')
                this.$store.commit('resetHomeServer')
                this.$store.commit('setGameInfo', {
                    name,
                    icon,
                    id
                })
                
                this.$store.commit('setCt','')
                this.$store.commit('setCi','')
                this.$store.commit('setCt2','')
                this.$store.commit('setCi2','')
                //道具市场 角色市场判断
                this.$store.commit('setHome',{prop_trade,role_trade})
                if(prop_trade == 0) {
                    this.$store.commit('changeHome',2)
                }else {
                    this.$store.commit('changeHome',1)
                }
                //角色市场 筛选全部重置
                this.$store.commit('resetAccPx')

                if (this.$route.name == 'home') {
                  
                    if(this.isIos) {
                        setTimeout(() => {
                            window.location.href = window.location.origin + '/home?id=' + id
                        }, 500);
                    }else {
                        this.$router.replace({
                            name: 'home',
                            query: Object.assign({}, this.$route.query, {
                                id
                            })
                        })
                    }
                }

                this.$parent.handleClose()        
                // this.$parent.handleSuccess({id,prop_trade,role_trade})
            },
            handleClose() {
                this.$parent.handleClose()
            },
            onSearch() {
                const keyword = (this.game_name || '').trim().toLowerCase()
                if (keyword == '') {
                    this.appList = this.allApplist
                    return
                }
                this.appList = this.allApplist.filter(item => {
                    return ((item.app_name || '') + '').toLowerCase().includes(keyword)
                })
            }
        },
    }
</script>
<style lang="less" scoped>
    .app_list {
        width: 100%;
        height: calc(var(--vh,1vh)*74);
        display: flex;
        flex-direction: column;
        .title {
            height: 9.6rem;
            padding-top: 2.4rem;
            position: relative;
            .close {
                position: absolute;
                right: 1rem;
                top: 1rem;
                font-size: 1.8rem;
                cursor: pointer;
            }
            .tit {
                text-align: center;
                font-size: 1.6rem;
                font-weight: 700;
                color: #000;
                margin-bottom: 1.4rem;
            }
            .van-search {
                padding: 0 1.6rem 0 1rem;
                height: 3.4rem;
                .van-search__content {
                    border-radius: 10rem;
                    padding-left: 1.2rem;
                    height: 100%;
                    .van-cell {
                        display: flex;
                        align-items: center;
                        font-size: 1.4rem;
                        /deep/.van-icon-search {
                            font-size: 1.6rem;
                            color: #B0B0B0;
                        }
                    }
                }
                .van-search__action {
                    font-size: 1.4rem;
                    color: var(--theme);
                    margin-left: .6rem;
                    padding: 0;
                }
            }
        }

        .content {
            flex: 1;
            padding: 1.2rem 2rem;
            padding-right: 0;
            display: flex;
            flex-wrap: wrap;
            justify-content: flex-start;
            align-content: flex-start;
            overflow-y: auto;
            .app_item {
                width: 22%;
                display: flex;
                flex-direction: column;
                justify-content: flex-start;
                align-items: center;
                margin-right: 3%;
                margin-bottom: 2rem;
                cursor: pointer;

                .icon {
                    width: 5rem;
                    height: 5rem;
                    border-radius: 0.8rem;
                    margin-bottom: 0.3rem;
                    overflow: hidden;
                    position: relative;
                    img {
                        width: 100%;
                        height: 100%;
                    }
                    &::after {
                        content: '';
                        position: absolute;
                        top: 0;
                        left: 0;
                        width: 100%;
                        height: 100%;
                        background-color: rgba(246, 111, 48, .51);
                        opacity: 0;
                    }
                }

                .name {
                    width: 100%;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    -webkit-line-clamp: 2;
                    -webkit-box-orient: vertical;
                    font-size: 1.2rem;
                    text-align: center;
                    transform: scale(0.95);
                    transition: center center;
                }

                &:nth-child(4n+4) {
                    margin-right: 0;
                }
                &.active {
                    .name {
                        color: var(--theme);
                    }
                    .icon {
                        &::after {
                            opacity: 1;
                        }
                    }
                }
            }
        }
    }
    .nodate {
        text-align: center;
        font-size: 1.4rem;
        color: #B0B0B0;
        padding: 1rem 0;
    }
</style>